// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"G0-z","dimensionLabel":"H0-z","styleChooserControlWrapper":"I0-z","styleChooserControl":"J0-z","disabled":"K0-z","giftCard":"L0-z","styleChooserText":"M0-z"};